import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const Hero = () => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage:
          'linear-gradient(135deg, rgba(2, 24, 53, 0.92) 0%, rgba(7, 60, 122, 0.92) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.72,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container>
          <Box textAlign="center" color="common.white">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 90, md: 130 },
                maxWidth: 360,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta de Cobertura Corporativa
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              Expo Petróleo
              <br />
              Maracaibo 2026
            </Typography>
            <Typography
              variant="h6"
              component="p"
              align="center"
              sx={{ fontWeight: 400, opacity: 0.95 }}
            >
              Exclusivo para Expositores | TNO Business x TNO Network
            </Typography>
            <Typography
              variant="body1"
              align="center"
              sx={{ mt: 2, opacity: 0.9, maxWidth: 760, mx: 'auto' }}
            >
              Autoridad energética, validación industrial y proyección de mercado
              para que su marca no solo esté presente en la feria, sino que
              destaque ante los tomadores de decisiones.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
